<template>
  <div class="fixed-header top-wrap">
    <div class="navbar">
      <router-link :to="'home'">
        <div class="left-logo">
          <img src="../images/index/logo-large.png" alt="" />
          <span
            class="logo-text hidden-sm-and-down"
            style="color: rgb(244, 244, 244);"
            >YUNKA</span
          >
        </div>
      </router-link>
      <div class="right-menu">
        <div v-if="sign" style="cursor: pointer">
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="el-dropdown-link">
              <div class="name">{{ user.userName}}</div><i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="center">个人中心</el-dropdown-item>
              <el-dropdown-item command="homePage">首页</el-dropdown-item>
              <el-dropdown-item command="agency">代理中心</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            type="primary"
            style="marginLeft:10px"
            @click="logoutAct"
            round
            >退出</el-button
          >
        </div>
        <div v-else>
          <el-button type="text" @click="centerDialogVisible = true"
            >登录</el-button
          >
          <el-button type="primary" @click="centerDialogVisible2 = true" round
            >注册</el-button
          >
        </div>
      </div>
    </div>
    <div class="sidebar-container">
      <div class="menus">
        <el-menu
          :default-active="activeName"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="transparent"
          text-color="#fff"
          active-text-color="#409EFF"
        >
          <el-menu-item index="1" class="menu"
            ><i class="el-icon-magic-stick sub-el-icon hidden-sm-and-down"></i
            ><span class="tit">首页</span></el-menu-item
          >
          <el-menu-item index="2" class="menu"
            ><i class="el-icon-postcard sub-el-icon hidden-sm-and-down"></i
            ><span class="tit">卡密购买</span></el-menu-item
          >
          <el-menu-item index="3" class="menu"
            ><i class="el-icon-chat-square sub-el-icon hidden-sm-and-down"></i
            ><span class="tit">用户评论</span></el-menu-item
          >
          <el-menu-item index="4" class="menu"
            ><i class="el-icon-position sub-el-icon hidden-sm-and-down"></i
            ><span class="tit">联系我们</span></el-menu-item
          >
        </el-menu>
      </div>
    </div>
    <el-dialog
      title="登录"
      :visible.sync="centerDialogVisible"
      :width="dialogWidth"
      center
      :modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="username">
          <el-input
            v-model="ruleForm.username"
            type="text"
            autocomplete="off"
            placeholder="用户名或邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <el-input
            v-model="ruleForm.password"
            type="password"
            autocomplete="off"
            placeholder="密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="注册"
      :visible.sync="centerDialogVisible2"
      :width="dialogWidth"
      center
      :modal="false"
    >
      <el-form
        :model="ruleForm2"
        :rules="rules2"
        ref="ruleForm2"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="username">
          <el-input
            v-model="ruleForm2.username"
            type="text"
            autocomplete="off"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <el-input
            v-model="ruleForm2.password"
            type="password"
            autocomplete="off"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="pwd2">
          <el-input
            v-model="ruleForm2.pwd2"
            type="password"
            autocomplete="off"
            placeholder="确认密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="email">
          <el-input
            v-model="ruleForm2.email"
            type="text"
            autocomplete="off"
            placeholder="邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="area">
          <el-select v-model="ruleForm2.area" placeholder="国家或地区">
            <el-option
              v-for="item in ops"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm2('ruleForm2')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { register, login, getPerson, logout } from "@/api";
import { Message } from "element-ui";
import {isMobile} from "../utils/utils";
export default {
  computed: {
    title() {
      return document.title;
    }
  },
  // computed: {
  //   sign() {
  //     return sessionStorage["token"];
  //   }
  // },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm2.pwd2 !== "") {
          this.$refs.ruleForm2.validateField("pwd2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      sign: false,
      activeName: "1",
      centerDialogVisible: false,
      centerDialogVisible2: false,
      ruleForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      ruleForm2: {
        username: "",
        password: "",
        pwd2: "",
        email: "",
        area: ""
      },
      dialogWidth: '60%',
      rules2: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          {min:6,max:16,message:'长度为6到16个字符',trigger:'blur'}
        ],
        password: [
          // { required: true, message: "密码不能为空", trigger: "blur" }
          {min:6,max:16,pattern:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/,message:'密码必须是数字和字母的组合，请输入6-16位数',trigger:'blur'},
          { validator: validatePass, trigger: "blur" }
        ],
        pwd2: [
          // { required: true, message: "请确认密码", trigger: "blur" }
          { validator: validatePass2, trigger: "blur" }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确格式",
            trigger: "blur"
          }
        ]
      },
      ops: [
        "香港",
        "台湾",
        "西班牙",
        "澳门",
        "美国",
        "澳大利亚",
        "加拿大",
        "中国",
        "日本",
        "韩国",
        "马来西亚",
        "菲律宾",
        "新加坡",
        "泰国",
        "越南"
      ],
      user: {}
    };
  },
  created() {
    if (isMobile()) {
      this.dialogWidth = '80%';
    } else {
      this.dialogWidth = '50%';
    }
    console.log(this.dialogWidth)
    this.sign = !!sessionStorage["token"] || false;
    if (sessionStorage["user"]) {
      this.user = JSON.parse(sessionStorage["user"]);
    } else {
      this.user = {};
    }
  },
  methods: {
    handleSelect(index) {
      this.activeName = index;
      switch (index) {
        case "1":
          this.$router.push("/home");
          break;
        case "2":
          this.$router.push("/buy");
          break;
        case "3":
          this.$router.push("/comments");
          break;
        case "4":
          this.$router.push("/contact");
          break;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          login(this.ruleForm).then(res => {
            sessionStorage.setItem("token", res.token);
            this.$emit("getStatus");
            this.sign = true;
            Message({
              type: "success",
              message: "登录成功!"
            });

            this.centerDialogVisible = false;
            getPerson().then(res => {
              this.user = res.data;
              sessionStorage.setItem("user", JSON.stringify(res.data));
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 注册
    submitForm2(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          register({ ...this.ruleForm2, deptId: 105 }).then(res => {
            Message({
              type: "success",
              message: "注册成功,请登录!"
            });

            this.centerDialogVisible2 = false;
            this.centerDialogVisible = true;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCommand(command) {
      if (command == "center") {
        this.$router.push("/user");
      } else if (command == "homePage") {
        this.$router.push("/home");
      } else{
        Message({
          type: "warning",
          message: "您的账号未开通代理权限!"
        });
      }
    },
    logoutAct() {
      logout(sessionStorage.getItem("token")).then(res => {
        Message({
          type: "success",
          message: "注销成功!"
        });
        this.sign = false;
        this.user = {};
        sessionStorage.clear();
        this.$emit("getStatus");
      });
    }
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(hash) {
        // const { hash } = window.location;
        if (hash.includes("/home" || hash == "/")) {
          this.activeName = "1";
        } else if (hash.includes("/buy")) {
          this.activeName = "2";
        } else if (hash.includes("/comments")) {
          this.activeName = "3";
        } else if (hash.includes("/contact")) {
          this.activeName = "4";
        } else {
          this.activeName = "";
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@bg: rgba(15, 2, 32, 1);
@color: #409eff;
 @media screen and (max-width: 600px) {
  .name{
    max-width: 100px!important;

  }
   .navbar{
     width:90%!important;
     margin: auto!important;
   }
   .tit{
     font-size: 12px!important;
   }
 }
.top-wrap {
  // background-color: @bg;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: 100%;
  height: 160px;
  -webkit-transition: width 0.28s;
  transition: width 0.28s;
  .right-menu {
    color: white;
    /deep/ .el-dropdown {
      color: white;
    }
    .el-dropdown-link{
      display: flex;
      align-items: center;
    }
    .name{
      display: inline-block;
          white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
  }
  .navbar {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 80%;
    padding: 10px 0;
    margin: 0 auto;
    height: 80px;
    line-height: 60px;
    overflow: hidden;
    position: relative;
    -webkit-box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
    box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
    box-sizing: border-box;
    .left-logo {
      img {
        width: 65px;
        margin-top: 18px;
        float: left;
      }
      .logo-text {
        float: left;
        font-size: 20px;
        font-weight: 700;
        margin-left: 8px;
      }
    }
  }
  .sidebar-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    .menus {
      width: 600px;
      // padding-bottom: 20px;
      /deep/.menu {
        &:hover {
          color: @color!important;
          background-color: transparent !important;
        }
      }
      /deep/ .is-active {
        background-color: transparent !important;
      }
      .el-menu.el-menu--horizontal {
        border-bottom: 0px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue